import type { ReactNode } from 'react';
import { cn } from './cn';

const tones = {
  neutral: 'bg-surface text-fg-muted ring-1 ring-line-strong ring-inset',
  brand: 'bg-teal-50 text-teal-700',
  success: 'bg-nav-active text-nav-active-fg',
  warning: 'bg-surface text-fg-muted ring-1 ring-line-strong ring-inset',
  danger: 'bg-surface text-fg ring-1 ring-line-strong ring-inset',
} as const;

export type BadgeTone = keyof typeof tones;

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
